import AboutAdditionalInfos from "@/components/about/AboutAdditionalInfos";
import AboutArticles from "@/components/about/AboutArticles";
import AboutBases from "@/components/about/AboutBases";
import AboutGeneral from "@/components/about/AboutGeneral";
import AboutPartner from "@/components/about/AboutPartner";
import AboutPlaylists from "@/components/about/AboutPlaylists";
import AboutTeam from "@/components/about/AboutTeam";
import { ContentContainer } from "@/components/ContentContainer";
import { NetworkLinks } from "@/components/network";
import theme from "@/styles/theme";
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import React, { useEffect } from "react";
import PageHead from "@/components/PageHead";

export default function About({page}) {

  return (
    <>
        <PageHead page={page} />
      <ContentContainer headline={page.headline} backgroundColor="transparent" image={page?.hero_image?.formats?.large?.url} />
      <Box
        sx={{
          zIndex: "3000",
          mt: -9,
          [theme.breakpoints.up("sm")]: {
            mt: -40,
          },
          "& .MuiContainer-root": {
            "&:nth-of-type(odd)": {
              "& > .MuiGrid-root": {
                backgroundColor: grey[100],
              },
            },
            "&:nth-of-type(even)": {
              "& > .MuiGrid-root": {
                backgroundColor: theme.palette.common.white,
              },
            },
            "&:last-of-type": {
              "& > .MuiGrid-root": {
                mb: 3,
                pt: 6,
                pb: 4,
                [theme.breakpoints.up("md")]: {
                  pb: 12,
                  mb: 14,
                },
              },
            },
          },
        }}
      >
        {page.content.map((content, idx) => {
          switch (content.__component) {
            case 'page-about.general': return <AboutGeneral content={content} key={idx} />;
            case 'page-about.links': return <NetworkLinks content={content} key={idx} />
            case 'page-about.additional-infos': return <AboutAdditionalInfos content={content} key={idx} />
            case 'page-about.bases': return <AboutBases content={content} key={idx} />
            case 'page-about.articles': return <AboutArticles content={content} key={idx} />
            case 'page-about.plalists': return <AboutPlaylists content={content} key={idx} />
            case 'page-about.team': return <AboutTeam content={content} key={idx} />
            case 'page-about.partner': return <AboutPartner content={content} key={idx} />
          }
        })}
      </Box>
    </>
  );
}

export const getStaticProps = async() => {
    const pageResponse = await fetch(`${process.env.NEXT_PUBLIC_API_URL || "http://localhost:1337"}/page-about-nhs`);
    const page = await pageResponse.json();

    return {
        props: {
            page
        },
        revalidate: parseInt(process.env.SSG_REVALIDATE_TIMEOUT)
    }
}